import React from "react";
import styled from "styled-components";
import { StyledButton } from "./StyledButton";
import { useNavigate } from "react-router-dom";
import { LANDING_PAGE_PATH } from "../../pathNames";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const Title = styled.h1`
  font-size: 48px;
  margin-bottom: 16px;
`;

const Subtitle = styled.p`
  font-size: 24px;
  color: grey;
`;

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const navigateToHome = () => {
    navigate(LANDING_PAGE_PATH);
  };

  return (
    <Wrapper>
      <Title>404</Title>
      <Subtitle>Page Not Found</Subtitle>
      <StyledButton onClick={navigateToHome}>Go Home</StyledButton>
    </Wrapper>
  );
};

export default NotFound;
